import { AbilityBuilder, Ability, AbilityClass } from '@casl/ability'
import User from '../types/User'

type Actions = any
type Hooks = any

export type AppAbility = Ability<[Actions, Hooks]>
export const AppAbility = Ability as AbilityClass<AppAbility>

export default function defineRulesFor(user: User) {
  const { can, rules } = new AbilityBuilder(AppAbility)

  if (user.isAppProcess !== undefined) {
    if (user.isAppProcess) {
      can('View', 'ApplicationProcess')
    } else {
      can('View', 'ProviderPortal')
    }
  }
  return rules
}

export function buildAbilityFor(user: User): AppAbility {
  return new AppAbility(defineRulesFor(user), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    detectSubjectType: (object: any) => object!.type
  })
}